import { watch } from 'vue';
import { stored_viewports } from './state';
import { uid_set_dirty_flag } from '@frontend/ui_display';

export * from './components/button';
export * from './components/modal';
export * from './state';
export * from './stored-viewport';

watch(
    () => stored_viewports,
    uid_set_dirty_flag,
    {
        deep: true
    }
);
